import React, { useState } from 'react';

const Accordion = (props: { title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; content: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion border border-sky-50 shadow rounded-md bg-white  my-2 ">
            <div className="accordion-header flex justify-between items-center p-4 bg-neutral-50" onClick={toggleAccordion}>
                <h2 className='text-black font font-medium text-base '>{props.title}</h2>
                <span className='text-black font font-regular text-base'>{isOpen ? '-' : '+'}</span>
            </div>
            {isOpen && (
                <div className="accordion-content pt-2 p-2 overflow-x-scroll lg:overflow-x-hidden lg:p-4" >
                    {props.content}
                </div>
            )}
        </div>
    );
};

export default Accordion;
